import { motion } from 'framer-motion';

export const TestimonialCard = ({ 
  imageUrl, 
  alt = "Témoignage ASA",
  index = 0
}) => {
  return (
    <motion.div 
      data-testid="testimonial-card"
      className="rounded-2xl overflow-hidden border border-white/10 transition-all duration-300 hover:-translate-y-2 hover:border-[#00A3FF]/30 hover:shadow-[0_10px_30px_rgba(0,163,255,0.15)] bg-[#0d0d0d]"
      initial={{ opacity: 0, scale: 0.95 }}
      whileInView={{ opacity: 1, scale: 1 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5, delay: index * 0.1 }}
    >
      <img 
        src={imageUrl} 
        alt={alt}
        className="w-full h-full object-cover"
        loading="lazy"
      />
    </motion.div>
  );
};

export default TestimonialCard;
